import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getPatientDemographicsSelector } from '../../selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { IPatientDemographicsState } from '../../store/patientDemographics.types'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getEmployerSelector } from '../../employer/selectors'
import { IEmployerState } from '../../employer/store/employer.types'
import { EmployerConstants } from '../store/employer.constants'
import { setPatientDemographics } from '../../store/patientDemographics.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveEmployer() {
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const employer: IEmployerState = yield select(getEmployerSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const updatedPatientDemographics = {
      ...patientDemographics,
      employer,
    }
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      patient: {
        ...pcrDoc.patient,
        patientDemographics: updatedPatientDemographics,
      },
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setPatientDemographics(updatedPatientDemographics))
    } catch (e) {
      yield put(throwPcrException(`saveEmployer() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveEmployerSaga() {
  yield takeLatest(
    [
      EmployerConstants.SET_INDUSTRY,
      EmployerConstants.SET_OCUPATION,
      EmployerConstants.SET_PRIMARY_BUSINESS,
      EmployerConstants.SET_ADDRESS1,
      EmployerConstants.SET_ADDRESS2,
      EmployerConstants.SET_CITY,
      EmployerConstants.SET_STATE,
      EmployerConstants.SET_ZIPCODE,
      EmployerConstants.SET_COUNTY,
      EmployerConstants.SET_COUNTRY,
      EmployerConstants.SET_PHONENUMBER,
      EmployerConstants.SET_PHONETYPE,
    ],
    performWithMutexHOG,
    saveEmployer
  )
}
